import { responsiveStyle } from '@synoptic/ui-kit/responsive/responsive-style.ts';
import { themeVars } from '@synoptic/ui-kit/theme/vars.ts';
import { borderRadius, fontWeight, space } from '@synoptic/ui-kit/tokens.ts';
import { typography } from '@synoptic/ui-kit/typography.ts';
import { style } from '@vanilla-extract/css';

export const editProfileForm = style({
  display: 'flex',
  flexDirection: 'column',
  gap: space.s24,
  width: '100%',
});

export const editProfileSubmitButton = style({
  display: 'flex',
  width: '100%',
  ...responsiveStyle({
    mobile: {
      marginTop: space.s28,
    },
  }),
});

export const editProfileAvatarContainer = style({
  display: 'flex',
  gap: space.s16,
  ...responsiveStyle({
    mobile: {
      flexDirection: 'column',
      alignItems: 'center',
    },
    tablet: {
      flexDirection: 'row-reverse',
      justifyContent: 'space-between',
      alignItems: 'unset',
    },
  }),
});

export const editProfileBgContainer = style({
  display: 'flex',
});

export const editProfileInputsContainer = style({
  display: 'flex',
  flexDirection: 'column',
  gap: space.s12,
});

export const editProfileAction = style({
  display: 'flex',
  flexDirection: 'column',
  gap: space.s16,
  ...responsiveStyle({
    mobile: {
      justifyContent: 'center',
    },
    tablet: {
      justifyContent: 'unset',
    },
  }),
});

export const editProfileActionLabel = style({
  ...typography.labelLg,
  fontWeight: fontWeight.bold,
  display: 'flex',
  ...responsiveStyle({
    mobile: {
      justifyContent: 'center',
    },
    tablet: {
      justifyContent: 'unset',
    },
  }),
});

export const editProfileActionLabelDescription = style({
  ...typography.bodyLg,
  color: themeVars.container.foreground.secondary,
  display: 'flex',
  ...responsiveStyle({
    mobile: {
      justifyContent: 'center',
    },
    tablet: {
      justifyContent: 'unset',
    },
  }),
});

export const editProfileAvatarActionButtons = style({
  display: 'flex',
  gap: space.s8,
  ...responsiveStyle({
    mobile: {
      justifyContent: 'center',
    },
    tablet: {
      justifyContent: 'unset',
    },
  }),
});

export const coverImageContainerBorderRadius = style({
  borderRadius: borderRadius.r16,
});

export const coverImageButtonContainer = style({
  backgroundColor: themeVars.container.primary.background.idle,
});
